<div class="card {{cssClass}}" *transloco="let t; read: 'ime.manufacturing.cost-price-components'">
  <div class="card-body">
    <div class="d-flex">
      <h5 class="d-inline my-auto">{{t('Cost price components')}}</h5>
      <button type="button" class="btn btn-sm btn-outline-primary ms-auto" *ngIf="!readonly" (click)="add()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}}
      </button>
      <button type="button" class="btn btn-sm btn-outline-danger ms-1" *ngIf="!readonly && selectedCpcs.length" (click)="removeSelected()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
        {{t('Remove selected')}}
      </button>
      <div *ngIf="!readonly && !container.CostPriceComponentPrices.length" #editDropdown="ngbDropdown" ngbDropdown [autoClose]="'outside'" container="body">
        <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle-without-arrow ms-1" ngbDropdownToggle role="button" aria-haspopup="true" aria-expanded="false">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bars-3"></svg>
        </button>
        <div ngbDropdownMenu>
          <app-copy-paste-menu-item [showCopy]="container.CostPriceComponentPrices.length" [allowCopyAll]="false" [readonly]="readonly"
                                    (onCopy)="copyPasteService.copy('CostPriceComponentPrice', selectedCpcs); editDropdown.close()"
                                    (onPaste)="paste(); editDropdown.close()"
                                    (onClipboardPaste)="paste(true); editDropdown.close()"></app-copy-paste-menu-item>
        </div>
      </div>
    </div>
    <p-table *ngIf="container.CostPriceComponentPrices.length"
             styleClass="p-datatable-xs p-datatable-borderless white-rows p-inner-table-auto mt-1"
             sortField="CostPriceComponentId"
             [value]="container.CostPriceComponentPrices"
             [rowHover]="true"
             [autoLayout]="false"
             [customSort]="true"
             (sortFunction)="customSort($event)"
             [(selection)]="selectedCpcs"
             dataKey="Id">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 30px">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="CostPriceComponentId">
            {{t('Component')}}
            <p-sortIcon field="CostPriceComponentId"></p-sortIcon>
          </th>
          <th>{{t('Price Expression')}}</th>
          <th pSortableColumn="Price">
            {{t('Price')}}
            <p-sortIcon field="Price"></p-sortIcon>
          </th>
          <th style="width: 140px">{{t('From/To')}}</th>
          <th class="wx-40">
            <div #editDropdown="ngbDropdown" ngbDropdown [autoClose]="'outside'" container="body">
              <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle-without-arrow" ngbDropdownToggle role="button" aria-haspopup="true" aria-expanded="false">
                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bars-3"></svg>
              </button>
              <div ngbDropdownMenu>
                <app-copy-paste-menu-item [allowCopyAll]="false" [readonly]="readonly"
                                          (onCopy)="copyPasteService.copy('CostPriceComponentPrice', selectedCpcs); editDropdown.close()"
                                          (onPaste)="paste(); editDropdown.close()"
                                          (onClipboardPaste)="paste(true); editDropdown.close()"></app-copy-paste-menu-item>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <td>
            <mes-cost-price-component-select name="cpc-{{row.Id}}"
                                             [items$]="costPriceComponentService.getAll$"
                                             [entityId]="row.CostPriceComponentId" [readonly]="readonly"
                                             (entityIdChange)="row.CostPriceComponentId = $event; changed.emit()"></mes-cost-price-component-select>
          </td>
          <td>
            <mes-web-expression-formula cssClass="form-control form-control-sm" [expression]="row.PriceExpression" [hasExternalFormula]="false" [readonly]="readonly" (changed)="changed.emit()"
                                        name="price-expression-{{row.Id}}"></mes-web-expression-formula>
          </td>
          <td>
            <input type="number" class="text-end form-control form-control-sm" id="price-{{row.Id}}" name="price-{{row.Id}}" [(ngModel)]="row.Price" [readonly]="readonly" (ngModelChange)="changed.emit()">
          </td>
          <td>
            <mes-date-range-picker [fromDate]="row.FromDate" [toDate]="row.ToDate" [hasButton]="false" [disabled]="readonly"
                                   (dateSelect)="setDateRange($event, row)"></mes-date-range-picker>
          </td>
          <td *ngIf="!readonly">
            <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="!readonly" (click)="remove(row)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
